<script>
export default {
  props: ['value'],
  data() {
    return {
      header: this.value.header,
      text: this.value.text,
      error: this.value.error,
      confirmText: this.value.confirmText || 'T_YES',
      showCancelButton: this.value.showCancelButton !== false,
    };
  },
  methods: {
    close() {
      this.$parent.close([null]);
    },
    resolve(answer) {
      this.value.resolve(answer);
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header(:class="$style.header")
    div(:class="$style.headerTitle") {{ $t(header) }}
    div(:class="$style.headerText", v-if="text")  {{ $t(text) }}
  div(:class="$style.content")
    ui-button(v-if="!error", :class="$style.actionBtn", colored="green", @click.native="resolve(true)",
      @keyup.enter.native="resolve(true)", data-test="CONFIRM_EDITING")  {{ $t(confirmText) }}
    ui-button(v-if="showCancelButton", :class="$style.actionBtn", colored="red", @click.native="resolve(false)",
      @keyup.enter.native="resolve(false)",
      data-test="CANCEL_EDITING")  {{ $t('T_CANCEL') }}
</template>

<style lang="sass" module>

.root
  display: block
.header
  padding: 24px 24px 10px
  &Title
    font-size: 18px
    display: flex
    justify-content: center
    max-width: 600px
    text-align: center
    overflow-wrap: break-word
    word-wrap: break-word
    word-break: break-all
    word-break: break-word
  &Text
    padding-top: 30px
    max-width: 600px
    min-width: 100%
    text-align: center
    overflow-wrap: break-word
    word-wrap: break-word
    word-break: break-all
    word-break: break-word
.content
  padding: 24px
  min-width: 532px
  display: flex
  justify-content: center
  gap: 50px
.actionBtn
  font-weight: 500
  color: $white
  &.success
    background: $color_green
  &.error
    background: $color_red
  &:hover
    opacity: 0.8

</style>
